import priceDisplayValue from '@@viewHelpers/priceDisplayValue.mjs';
import { PriceYearMonth } from '@fasstech/middle-design-system';
import { isNil } from 'ramda';

export const TariffRowPrice = ({ priceValue, priceUnit = '€', yearlyPriceValue = null }) => {
  const priceData = {
    year: isNil(yearlyPriceValue) ? priceDisplayValue(priceValue * 12) : priceDisplayValue(yearlyPriceValue),
    month: priceDisplayValue(priceValue),
    currencySymbol: priceUnit
  };

  return (
    <div
      className={'flex items-center justify-center h-full py-2 rounded text-center [&>div>div]:flex [&>div>div]:items-center [&>div>div]:justify-center'}
    >
      <PriceYearMonth prices={priceData} />
    </div>
  );
};
